import TiffanyGrant from "./../../assets/guest_pictures/TiffanyGrant.png";
import SarahNicoleRobles from "./../../assets/guest_pictures/SarahNicoleRobles.jpg"
import TomBloom from "./../../assets/guest_pictures/TomBloom.png";
import MorganBerry from "./../../assets/guest_pictures/MorganBerry.jpg";
import ZachPokres from "./../../assets/guest_pictures/ZachPokres.jpg";


import { GuestProps } from "./Guest";

export const GUESTSCONFIG: GuestProps[] = [
  {
    name: "Tiffany Grant",
    bodyText: `Best known as Asuka from Evangelion, Tiffany's worked in anime since 1994. Her 1700+ anime credits include Blue Seed, Fairy Tail, Full Metal Alchemist, One Piece, Akame Ga Kill and Ushio &Tora. Recent projects include Neon Genesis Evangelion: Anima (SevenSeasAudiobooks.com). 
    
Select video games: Warframe, Neversong, Brawl Stars, Paladins, Smite and AFK Arena. Ms. Grant wrote English dubbing scripts for titles such as Tears to Tiara, Parasyte-the-Maxim & several subtitled scripts. Ms. Grant has also worked for many years in theatre, commercials and film.

See her on the main stage at our voice actor's panel "Tiffany Grant, Morgan Berry, Sarah-Nicole Robles, and Zach Pokres: Behind the Voices" at WreckCon 2026! She will be selling and signing merch throughout the day as well!`,
    picture: TiffanyGrant,
    role: "Voice Actress",
  },
  {
    name: "Morgan Berry",
    role: "Voice Actress",
    bodyText: `Morgan Berry is a professional voice actor, singer, and YouTuber; best known for her voice roles in various anime television series, films, video games, and web series. Some of the many franchises Morgan has voiced for include: "Pokemon", "Dragon Ball", "Beyblade", "Frieren", "My Hero Academia", "Final Fantasy", "Inuyasha", "Fire Emblem", “Borderlands”, "Miraculous Ladybug", "Sword Art Online", "One Piece", "Fruits Basket", "Food Wars", "Love Live!", "The Rising of the Shield Hero", "Cells at Work", “Clevatess", and more! In addition to acting, Morgan is a professional recording artist and YouTube Personality under the name "The Unknown Songbird" with over 10 million views in total.

Catch her at our voice actor's panel ""Tiffany Grant, Morgan Berry, Sarah-Nicole Robles, and Zach Pokres: Behind the Voices" on the main stage! She will also be signing autographs and prints. `,
    picture: MorganBerry,
  },
  {
    name: "Sarah-Nicole Robles",
    bodyText: `Sarah-Nicole was born and raised in New Jersey. She left home to attend college at Carnegie Mellon University in Pittsburgh where she got her BFA in Acting. From there she moved to LA where she continued to pursue Acting. She is currently voicing Luz Noceda for Disney's The Owl House. She can also be heard on Nickelodeon's Billy Dilley's Super-Duper Subterranean Summer, Dreamworks' Boss Baby: Back in Business, Disney's Star Darlings and Olaf's Frozen Adventure. On camera she can also be seen on episodes of NCIS LA and Grey's Anatomy.  When she's not working she loves reading, baking, and horror movies.
    
Catch her at our voice acting panel "Tiffany Grant, Morgan Berry, Sarah-Nicole Robles, and Zach Pokres: Behind the Voices" on the main stage at WreckCon 2026! She will also be signing prints and selling merch throughout the day.`,
    picture: SarahNicoleRobles,
    role: "Voice Actress",
  },
  {
    name: "Zach Pokres",
    bodyText: `Zach is a California-based voice actor with years of experience in animation and games. You may recognize him from Indigo Park as Finely, MiSide as the player character, or from the viral "Stop Posting About Among Us" meme. When he's not in the booth, Zach is busy running his voice acting and dubbing studio ZAUDIO or livestreaming on Twitch.

Catch him on the main stage at our voice actor's panel ""Tiffany Grant, Morgan Berry, Sarah-Nicole Robles, and Zach Pokres: Behind the Voices" at WreckCon 2026!`,
    picture: ZachPokres,
    role: "Voice Actor",
  },
  {
    name: "Tom Bloom",
    role: "Comic Author, TTRPG Designer",
    bodyText: `Tom Bloom is a comic author and game designer best known for the webcomic Kill Six Billion Demons and the role playing games Lancer RPG, CAIN, and Maleghast. 

If you've ever struggled with worldbuilding, whether it be for story writing or TTRPG game creation, check out Tom's Worldbuilding panel on the main stage!`,
    picture: TomBloom,
  },
];
